import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "product-updates",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "product-updates" */ "./components"),
        import(
          /* webpackChunkName: "product-updates" */ "./modules/ProductUpdatesModules"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const productUpdateModule = importedModule1;
        injectReducer(store, {
          key: productUpdateModule.NAME,
          reducer: productUpdateModule.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
